var $1e398002a8be3d02$exports = {};
$1e398002a8be3d02$exports = {
    "collectionLabel": `Sugest\xf5es`
};


export {$1e398002a8be3d02$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
